<template>
	<div>
		<v-row>
			<v-col cols="12" md="3">
				<v-chip class="mx-2" color="success" outlined style="cursor: pointer;" @click="editMember">
					<v-icon left>
						mdi-account-outline
					</v-icon>
					{{ data.member.fullName }}
					(&lrm;{{ data.member.userName }})
				</v-chip>
			</v-col>
			<v-col cols="12" md="3">
				<v-chip class="mx-2" color="success" outlined>
					<v-icon left>
						mdi-account-outline
					</v-icon>
					موبایل: {{ data.member.mobile }}
				</v-chip>
			</v-col>
			<v-col cols="12" md="6">
				<div style="text-align:center" v-if="selectedUserLoan2 != null">
					<v-row>
						<v-col cols="4" md="4">
							{{ selectedUserLoan2.loanModel.title }}<br /> {{ selectedUserLoan2.amount.toString().toPriceFormat() }}
							تومان
						</v-col>
						<v-col cols="4" md="4">
							شروع: <br />{{ selectedUserLoan2.startDate_Persian.date }}
						</v-col>
						<v-col cols="4" md="4">
							هر قسط: <br />{{ selectedUserLoan2.installment.toString().toPriceFormat() }} تومان
						</v-col>
					</v-row>
				</div>
			</v-col>
		</v-row>
		<v-divider class="my-3" />
		<div>
			<v-tabs v-model="activeTab" @change="tabChanged" :class="{ 'hide': selectedUserLoan2 }" centered color="secondary" slider-color="secondary">
				<v-tab :key="0" class="can-hide">پرونده وام ها</v-tab>
				<v-tab :key="1" style="width:10px;display: none;"></v-tab>
				<v-tab :key="2" class="can-hide">درخواست وام ها</v-tab>
				<v-tab :key="3" class="can-hide">تراکنش ها</v-tab>
				<v-tab :key="4" class="can-hide">پیامک ها</v-tab>
				<v-tab :key="5" class="can-hide">تیکت ها</v-tab>
				<v-tabs-items v-model="activeTab" touchless class="mt-6">
					<v-tab-item :key="0">
						<v-row v-if="loans && loans.length > 2">
							<v-col cols="12" md="12" class="text-center">
								<v-btn class="mx-auto" color="secondary" dark @click="add">
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									افزودن وام
								</v-btn>
							</v-col>
						</v-row>
						<v-row v-if="loading">
							<v-col cols="12">
								<div class="success--text text-h4 text-center">
									در حال دریافت اطلاعات ...
								</div>
							</v-col>
						</v-row>
						<v-row v-else-if="!loans || loans.length == 0">
							<v-col cols="12">
								<div class="red--text text-h4 text-center">
									تاکنون وامی برای این شخص ثبت نشده است.
								</div>
							</v-col>
						</v-row>
						<v-row v-else class="loan-cards">
							<v-col v-for="l in loans" :key="l.id" cols="12" md="12">
								<v-card style="overflow:hidden" class="card ma-2" elevation="3">
									<v-row>
										<v-col cols="12" sm="4">
											<v-list-item three-line>
												<v-list-item-content>
													<v-list-item-title class="headline mb-3 pb-2 secondary--text" style="border-bottom: 1px dashed rgb(191 191 191);">
														<span class="black--text">نوع وام:</span> {{ l.loanModel.title }}
													</v-list-item-title>
													<v-list-item-subtitle class="secondary--text"><span class="black--text">شماره وام:</span>
														{{
															l.code }}</v-list-item-subtitle>
													<v-list-item-subtitle class="secondary--text"><span class="black--text">تاریخ شروع:</span>
														{{
															l.startDate_Persian.date }}</v-list-item-subtitle>
													<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ وام:</span>
														{{
															l.amount.toString().toPriceFormat() }} تومان</v-list-item-subtitle>
													<v-list-item-subtitle class="secondary--text"><span class="black--text">باز پرداخت با
															بهره:</span> {{ l.payableAmount.toString().toPriceFormat() }}
														تومان</v-list-item-subtitle>
													<v-list-item-subtitle class="secondary--text"><span class="black--text">تعداد
															اقساط:</span> {{
																l.month }} {{ (l.monthGap > 1 ? `قسط ${l.monthGap} ماهه` : "") }}</v-list-item-subtitle>
													<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ هر
															قسط:</span> {{
																l.installment.toString().toPriceFormat() }} تومان</v-list-item-subtitle>
													<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ پیش پرداخت:</span> {{ l.preDepositAmount.toString().toPriceFormat() }} تومان</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>

										</v-col>
										<v-col cols="12" sm="4">
											<v-list-item three-line>
												<v-list-item-content>
													<v-list-item-title class="headline mb-3 pb-2" style="border-bottom: 1px dashed rgb(191 191 191);">
														بازپرداخت ها
													</v-list-item-title>
													<v-list-item-subtitle class="secondary--text"><span class="black--text">تعداد اقساط
															پرداختی:</span> {{ l.paidCount }}</v-list-item-subtitle>
													<v-list-item-subtitle class="secondary--text"><span class="black--text">اقساط پرداخت
															شده:</span>
														{{ l.paid.toString().toPriceFormat() }} تومان</v-list-item-subtitle>
													<v-list-item-subtitle><span :class="{ 'red--text': l.delays > 0 }">دیرکرد</span> / <span :class="{ 'success--text': l.delays < 0 }">زودکرد</span>: <span class="secondary--text">{{
														l.delays.toString().toPriceFormat() }} تومان</span></v-list-item-subtitle>
													<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ
															باقیمانده:</span>
														{{ Math.abs(l.remain).toString().toPriceFormat() }} تومان <span class="success--text" v-if="l.remain < 0">بستانکار</span><span class="red--text" v-if="l.remain > 0">بدهکار</span></v-list-item-subtitle>
													<v-list-item-subtitle class="secondary--text"><span class="black--text">تسویه شده:</span>
														{{
															l.isCheckouted ? 'بلی' : 'خیر' }}</v-list-item-subtitle>
													<v-list-item-subtitle class="secondary--text" v-if="l.isCheckouted">
														<span class="black--text">تاریخ تسویه:</span> {{ l.checkoutDate_Persian.date }}
													</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>

										</v-col>
										<v-col cols="12" sm="4">
											<v-list-item three-line>
												<v-list-item-content>
													<v-list-item-title class="headline mb-3 pb-2" style="border-bottom: 1px dashed rgb(191 191 191);">
														توضیحات:
													</v-list-item-title>
													<div style="white-space: pre-line;">
														{{ l.description ? l.description : 'توضیحاتی ثبت نشده است.' }}
													</div>
												</v-list-item-content>

												<div class="checkouted-mark" v-if="l.isCheckouted">تسویه شده</div>
											</v-list-item>

											<v-list-item three-line class="mt-3">
												<v-list-item-content>
													<v-list-item-title class="headline mb-3 pb-2" style="border-bottom: 1px dashed rgb(191 191 191);">
														نماینده:
													</v-list-item-title>
													<div style="white-space: pre-line;">
														{{ l.agentModel ? l.agentModel.businessName : 'بدون نماینده' }}
													</div>
													<div v-if="l.agentModel">
														سهم نماینده: {{ l.agentPrice.toString().toPriceFormat() }}
													</div>
												</v-list-item-content>
											</v-list-item>
										</v-col>
									</v-row>

									<v-card-actions class="flex-wrap">
										<v-btn outlined rounded text @click="showInstallments(l)">
											مشاهده اقساط و پرداخت
										</v-btn>
										<v-btn outlined rounded text @click="showAssurances(l)">
											تضامین
										</v-btn>
										<v-btn outlined rounded text @click="showCheckoutAmount(l)">
											مشاهده مبلغ تسویه آنی
										</v-btn>
										<v-spacer />
										<v-btn class="mx-1" fab dark small color="secondary" title="ویرایش وام" @click="edit(l)">
											<v-icon dark>
												mdi-square-edit-outline
											</v-icon>
										</v-btn>
										<v-btn :disabled="!checkPermission('Delete_Loan')" class="mx-2" fab dark small color="pink" title="حذف وام" @click="remove(l)">
											<v-icon dark>
												mdi-trash-can-outline
											</v-icon>
										</v-btn>
										<v-btn v-if="checkActivePart('thirdParty')" class="mx-1" fab dark small outlined color="pink" @click="() => { selectedUserLoan = l; dialogThirdParty = true }" title="ارتباط با دیگر نرم افزار ها">
											<v-icon dark>
												mdi-apache-kafka
											</v-icon>
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="12" class="text-center">
								<v-btn v-if="!loading" class="mx-auto" color="secondary" dark @click="add">
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									افزودن وام
								</v-btn>
							</v-col>
						</v-row>
					</v-tab-item>
					<v-tab-item :key="1">
						<loan-installments ref="installments" v-if="activeTab == 1" :data="{ userloan: selectedUserLoan2, adminPanel: true }" @changed="getDataById" @back="loanInstallmentsBack" />
					</v-tab-item>
					<v-tab-item :key="2">
						<v-data-table :loading="loanRequestLoading" :headers="headers" :items="loanRequestItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" class="elevation-1">
							<template v-slot:item="row">
								<tr>
									<td>
										<div class="info--text" style="cursor:pointer" @click="editLoanRequest(row.item)">
											<span class="text-small info--grey">شماره درخواست:</span> {{ row.item.code }}
										</div>
										<div class="">
											<small class="text-small info--grey">مبلغ: {{ row.item.amount.toString().toPriceFormat() }}</small>
										</div>
										<div class="">
											<small class="text-small info--grey">تاریخ: &lrm;{{ `${row.item.requestDate_Persian.date} ${row.item.requestDate_Persian.time}` }}</small>
										</div>
										<div><small>{{ row.item.loanModel.title }}</small></div>
									</td>
									<td class="text-center">
										{{ row.item.str_Status }}
									</td>
									<td>
										<div @click="editAgent({ id: row.item.agentModel.id })" style="cursor:pointer">
											{{ row.item.agentModel ? row.item.agentModel.businessName : '' }}
										</div>
										{{ row.item.memberModel && row.item.memberModel.marketerName ? row.item.memberModel.marketerName : '' }}
									</td>
									<td class="text-center">
										{{ row.item.agentModel ? row.item.str_AgentStatus : '' }}
									</td>
									<td>
										{{ row.item.adminDescriptionPrivate || "-" }}
									</td>
									<td class="text-center">
										<v-btn class="mx-1" fab dark small color="secondary" @click="editLoanRequest(row.item)">
											<v-icon dark>
												mdi-square-edit-outline
											</v-icon>
										</v-btn>
										<v-btn class="mx-1" fab dark small color="pink" @click="removeLoanRequest(row.item)">
											<v-icon dark>
												mdi-trash-can-outline
											</v-icon>
										</v-btn>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-tab-item>
					<v-tab-item :key="3">
						<v-card color="white" class="pa-3">
							<online-gateway-payments ref="onlineGatewayPayments" :data="{ memberId: data.member.id }" :autoLoad="false" />
						</v-card>
					</v-tab-item>
					<v-tab-item :key="4">
						<v-card color="white" class="pa-3">
							<sms-list ref="smsList" :mobile="data.member.mobile" :autoLoad="false" />
						</v-card>
					</v-tab-item>
					<v-tab-item :key="5">
						<v-card color="white" class="pa-3">
							<tickets ref="tickets" :memberId="data.member.id" userType="admin" />
						</v-card>
					</v-tab-item>
				</v-tabs-items>
			</v-tabs>
		</div>

		<v-dialog v-model="dialogModifyUserLoan" scrollable persistent max-width="600px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ثبت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyUserLoan = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-user-loan ref="modifyUserLoan" v-if="dialogModifyUserLoan" :data="selectedUserLoan" @callbck="callbck_userLoan" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogModifyLoanPayment" scrollable persistent max-width="900px">
			<v-card>
				<v-card-title>
					<div><span class="headline">پرداخت قسط</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyLoanPayment = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-loan-payment ref="modifyLoanPayment" v-if="dialogModifyLoanPayment" :data="selectedLoanPayment" @callbck="callbck_loanPayment" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogAssurance" scrollable persistent max-width="900px">
			<v-card>
				<v-card-title>
					<div><span class="headline">تضامین</span></div>
					<v-spacer />
					<v-btn @click="dialogAssurance = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<Assurance ref="assurance" v-if="dialogAssurance" :data="selectedUserLoan" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogCheckoutAmount" max-width="400px">
			<v-card>
				<v-card-title>
					<div></div>
				</v-card-title>
				<v-container>
					<div style="text-align:center">
						<div class="mb-2">مبلغ قابل تسویه</div>
						<h3 :class="[checkoutAmount > 0 ? 'red--text' : 'success--text']">
							{{ checkoutAmount.toString().toPriceFormat() }} <span v-if="!isNaN(checkoutAmount)">{{ checkoutAmount > 0 ?
								'بدهکار' : 'بستانکار' }}</span></h3>
					</div>
				</v-container>
				<v-card-actions>
					<v-spacer />
					<v-btn @click="dialogCheckoutAmount = false">
						بستن
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogMember" scrollable persistent max-width="900px">
			<modify-member :data="selectedMember" v-if="dialogMember" @callbck="callbckMember" @close="dialogMember = false" />
		</v-dialog>

		<v-dialog v-model="dialogLoanRequest" scrollable persistent max-width="1100px">
			<modify-request ref="modifyRequest" v-if="dialogLoanRequest" :data="selectedRequest" @callbck="callbck_loanRequest" @close="dialogLoanRequest = false" />
		</v-dialog>

		<v-dialog v-model="dialogAgent" scrollable persistent max-width="700px">
			<v-card>
				<v-card-title>
					<span class="headline">مشخصات نماینده</span>
					<v-spacer />
					<v-btn @click="dialogAgent = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ModifyAgent :data="selectedAgent" v-if="dialogAgent" @callbck="agent_callbck" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogThirdParty" scrollable persistent>
			<v-card>
				<v-card-title>
					<span class="headline">ارتباط با دیگر نرم افزارها</span>
					<v-spacer />
					<v-btn @click="dialogThirdParty = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<thirdParty v-if="dialogThirdParty" @callbck="callbck_thirdParty" :entityType="'UserLoan'" :entityId="selectedUserLoan.id" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>


		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import LoanInstallments from './LoanInstallments.vue'
	import ModifyUserLoan from './ModifyUserLoan.vue'

	export default {
		name: 'ManageLoanView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			Assurance: () => import('@/components/forms/Assurance.vue'),
			ModifyAgent: () => import('@/views/admin/agent/ModifyAgent'),
			'sms-list': () => import('@/views/admin/SMSList.vue'),
			'online-gateway-payments': () => import('@/views/admin/Report/OnlineGatewayPayments.vue'),
			'modify-member': () => import('@/views/admin/ModifyMember'),
			'loan-installments': LoanInstallments,
			'modify-user-loan': ModifyUserLoan,
			'modify-loan-payment': () => import('./ModifyLoanPayment.vue'),
			'modify-request': () => import('./ModifyLoanRequest.vue'),
			'thirdParty': () => import('@/views/admin/ThirdParty.vue'),
			'tickets': () => import('@/components/ticket/AdminTickets.vue'),
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				selectedAgent: {},
				userloan: null,
				activeTab: 0,
				loading: false,
				loanRequestLoading: false,
				errorMessages: '',
				localData: {},
				selectedMember: {},
				checkoutAmount: 0,
				dialogMember: false,
				dialogModifyUserLoan: false,
				dialogModifyLoanPayment: false,
				dialogCheckoutAmount: false,
				dialogAssurance: false,
				dialogLoanRequest: false,
				dialogThirdParty: false,
				dialogAgent: false,
				selectedUserLoan: null,
				selectedUserLoan2: null,
				selectedLoanPayment: null,
				loans: [],
				loanRequestItems: [],
				selectedRequest: null,
				headers: [
					{
						text: 'اطلاعات درخواست',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 170
					},
					{
						text: 'وام',
						align: 'start d-none',
						sortable: true,
						value: 'loanModel.title',
					},
					{
						text: 'مبلغ',
						align: 'center d-none',
						sortable: true,
						value: 'amount',
					},
					{
						text: 'تاریخ ثبت درخواست',
						align: 'center d-none',
						sortable: true,
						value: 'requestDate_Persian',
					},
					{
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'str_Status',
					},
					{
						text: 'نماینده/بازاریاب',
						align: 'center',
						sortable: true,
						value: 'agentModel.businessName',
					},
					{
						text: 'نماینده/بازاریاب',
						align: 'center d-none',
						sortable: true,
						value: 'memberModel.marketerName',
					},
					{
						text: 'وضعیت نماینده',
						align: 'center',
						sortable: true,
						value: 'str_AgentStatus',
					},
					{
						text: 'نظر کارشناس',
						align: 'start',
						sortable: true,
						value: 'adminDescription',
					},
					{
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						width: 150,
					},
				],
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			add() {
				this.selectedUserLoan = { id: emptyId, memberModel: this.data.member }
				this.dialogModifyUserLoan = true
			},
			edit(item) {
				this.selectedUserLoan = item
				this.dialogModifyUserLoan = true
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/userloan/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			loadData() {
				this.activeTab = 0
				this.loading = true
				api.get('admin/userloan/GetLoansByUserId/' + this.data.member.id, null)
					.then(
						response => {
							this.loans = response
						})
					.catch(err => {
						toast.error(err.message)
					}).finally(x => {
						this.loading = false
					})
			},
			getDataById(id) {
				api.get('admin/userloan/get/' + id, null)
					.then(
						response => {
							let index = this.loans.findIndex(x => x.id == id)
							if (index > -1)
								this.loans[index] = response
							this.selectedUserLoan2 = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			showInstallments(userLoan) {
				this.selectedUserLoan2 = userLoan
				this.activeTab = 1
			},
			payInstallment(userLoan) {
				this.dialogModifyLoanPayment = true
				this.selectedLoanPayment = { userLoanModel: userLoan, installmentNumber: userLoan.paidCount + 1, amount: Math.min(userLoan.remain, userLoan.installment) }
				this.$nextTick(() => {
					this.$refs.modifyLoanPayment.prepareData()
				})
			},
			showCheckoutAmount(userLoan) {
				this.dialogCheckoutAmount = true
				this.checkoutAmount = "در حال دریافت اطلاعات..."
				api.get('admin/userloan/getCheckoutAmount/' + userLoan.id, null)
					.then(
						response => {
							this.checkoutAmount = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			showAssurances(userLoan) {
				this.dialogAssurance = true
				this.selectedUserLoan = userLoan
			},
			callbck_userLoan(result) {
				this.dialogModifyUserLoan = false
				if (result) { this.loadData() }
			},
			callbck_loanPayment(result) {
				this.dialogModifyLoanPayment = false
				if (result) { this.loadData() }
			},
			loanInstallmentsBack() {
				this.activeTab = 0
				this.selectedUserLoan2 = null
			},
			editMember(item) {
				this.selectedMember = this.data.member
				this.dialogMember = true
			},
			callbckMember(result) {
				this.dialogMember = false
			},
			tabChanged(tab) {
				if (tab == 2)
					this.loadDataLoanRequest(true)
			},
			loadDataLoanRequest() {
				this.loanRequestLoading = true
				api.get('admin/userLoanRequest/list?memberId=' + this.data.member.id, null)
					.then(response => {
						this.loanRequestItems = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loanRequestLoading = false
					})
			},
			editLoanRequest(item) {
				this.dialogLoanRequest = true
				this.selectedRequest = item
			},
			callbck_loanRequest(result) {
				// this.dialog = false
				if (result) {
					this.loadDataLoanRequest()
				}
			},
			async removeLoanRequest(item) {
				if (!item) {
					return
				}

				if (
					await this.$refs.confirm.open(
						'توجه',
						'آیا از حذف این آیتم مطمئن هستید؟',
					)
				) {
					api
						.post('admin/userLoanRequest/delete/' + item.id)
						.then(response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.loadDataLoanRequest()
						})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			editAgent(agent) {
				if (!agent?.id)
					return
				this.selectedAgent = agent
				this.dialogAgent = true
			},
			agent_callbck(result) {
				this.dialogAgent = false
			},
			callbck_thirdParty() {
				this.dialogThirdParty = false
			}
		},
	}
</script>
<style scoped>
	.v-tabs .v-tabs-bar {
		display: none;
	}

	.v-tabs.hide .can-hide,
	.v-tabs.hide .v-tabs-slider-wrapper {
		display: none;
	}
</style>
